import React from 'react';
import { motion } from 'framer-motion';
export function TransformationSection() {
  return <section className="bg-brand-cream py-16 px-4" data-id="element-187">
      <div className="max-w-5xl mx-auto" data-id="element-188">
        <motion.h2 className="text-3xl md:text-5xl font-black text-center text-brand-darkGreen mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-189">
          🔄 TRANSFORMACIÓN
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-190">
          {/* Antes */}
          <motion.div className="bg-white rounded-2xl overflow-hidden shadow-lg border-2 border-brand-red/20" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-191">
            <div className="bg-brand-red text-white text-center py-4" data-id="element-192">
              <h3 className="text-2xl font-bold" data-id="element-193">Antes</h3>
            </div>
            <div className="p-8 space-y-6" data-id="element-194">
              {['“¿Qué hago hoy?”', 'Improvisación constante', 'Siempre lo mismo', 'Pocas verduras'].map((item, index) => <div key={index} className="flex items-center gap-4" data-id="element-195">
                  <span className="text-brand-red text-2xl font-bold" data-id="element-196">❌</span>
                  <span className="text-lg font-medium text-gray-700" data-id="element-197">
                    {item}
                  </span>
                </div>)}
            </div>
          </motion.div>

          {/* Después */}
          <motion.div className="bg-white rounded-2xl overflow-hidden shadow-2xl border-4 border-brand-green transform md:-translate-y-4" initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-198">
            <div className="bg-brand-green text-white text-center py-6" data-id="element-199">
              <h3 className="text-3xl font-bold" data-id="element-200">Después</h3>
            </div>
            <div className="p-8 space-y-6" data-id="element-201">
              {['Tenés ideas claras', 'Sabés qué cocinar', 'Organizás la semana', 'Los chicos comen mejor', 'Menos estrés, más orden'].map((item, index) => <div key={index} className="flex items-center gap-4" data-id="element-202">
                  <span className="text-brand-green text-2xl font-bold" data-id="element-203">
                    ✔
                  </span>
                  <span className="text-xl font-bold text-brand-darkGreen" data-id="element-204">
                    {item}
                  </span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}